import { render, staticRenderFns } from "./VSnackbarQueue.vue?vue&type=template&id=fc28922e"
import script from "./VSnackbarQueue.vue?vue&type=script&lang=js"
export * from "./VSnackbarQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports